export default {
  'table.total': 'Gesamt: {{amount}} Einträge',
  'table.actions': 'Aktionen',
};
